import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerSections = [
    {
      title: 'Solutions',
      links: [
        { label: 'All Solutions', path: '/solutions-categories' },
        { label: 'Solution Finder', path: '/solution-finder-tool' },
        { label: 'Knowledge Hub', path: '/knowledge-hub' },
        { label: 'Authority Center', path: '/authority-center' },
      ],
    },
    {
      title: 'Resources',
      links: [
        { label: 'Resource Library', path: '/resource-library' },
        { label: 'Case Studies', path: '/knowledge-hub' },
        { label: 'Documentation', path: '/knowledge-hub' },
        { label: 'Blog', path: '/knowledge-hub' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us', path: '/homepage' },
        { label: 'Contact', path: '/consultation-gateway' },
        { label: 'Careers', path: '/homepage' },
        { label: 'Admin', path: '/admin-dashboard' },
      ],
    },
  ];

  const socialLinks = [
    { icon: 'Linkedin', label: 'LinkedIn', href: '#' },
    { icon: 'Twitter', label: 'Twitter', href: '#' },
    { icon: 'Github', label: 'GitHub', href: '#' },
    { icon: 'Mail', label: 'Email', href: 'mailto:contact@systemsauthority.pro' },
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          <div className="lg:col-span-2">
            <Link to="/homepage" className="flex items-center space-x-3 mb-4">
              <img 
                src="/assets/images/b_two_b_codes_logo_new.png" 
                alt="B2B Codes Logo - B2B Data Intelligence Platform"
                className="w-20 h-20 object-contain"
              />
              <span className="text-2xl font-extrabold text-foreground">
                B2B Codes
              </span>
            </Link>
            <p className="text-muted-foreground mb-6 max-w-md">
              Your trusted partner in B2B data intelligence. Transform in-market visitor data into smart, data-driven email campaigns, e-commerce optimization, and accessibility solutions.
            </p>
            <div className="flex items-center space-x-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.label}
                  href={social?.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-lg bg-muted hover:bg-primary hover:text-primary-foreground flex items-center justify-center transition-all duration-250"
                  aria-label={social?.label}
                >
                  <Icon name={social?.icon} size={20} />
                </a>
              ))}
            </div>
          </div>

          {footerSections?.map((section) => (
            <div key={section?.title}>
              <h3 className="font-semibold text-foreground mb-4">
                {section?.title}
              </h3>
              <ul className="space-y-3">
                {section?.links?.map((link) => (
                  <li key={link?.label}>
                    <Link
                      to={link?.path}
                      className="text-muted-foreground hover:text-accent transition-colors duration-250"
                    >
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground">
              © {currentYear} B2B Codes. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link
                to="/homepage"
                className="text-sm text-muted-foreground hover:text-accent transition-colors duration-250"
              >
                Privacy Policy
              </Link>
              <Link
                to="/homepage"
                className="text-sm text-muted-foreground hover:text-accent transition-colors duration-250"
              >
                Terms of Service
              </Link>
              <Link
                to="/homepage"
                className="text-sm text-muted-foreground hover:text-accent transition-colors duration-250"
              >
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;